module.exports = __webpack_public_path__ + "img/responseTime.272b76b6.png";